import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import cn from 'classnames';
import Conditions from './conditions';
import Details from './details';

const CONDITIONS_TAB = 'offerPolicy';
const DETAILS_TAB = 'offerDetails';

const Tabs = ({ popInConditions }) => {
  const tabNames = Object.keys(popInConditions);
  const tabsContent = Object.values(popInConditions);

  const [activeTab, setActiveTab] = useState(CONDITIONS_TAB);

  return (
    <div className="popin-condition">
      <div className="popin-condition__hd">
        {tabNames.map((tab, index) => {
          return (
            // eslint-disable-next-line jsx-a11y/click-events-have-key-events
            <div
              id={tab}
              className={cn(`${tab}-tab`, { active: activeTab === tab })}
              key={uuidv4()}
              role="link"
              tabIndex={0}
              onClick={() => setActiveTab(tab)}
            >
              {tabsContent[index].title}
            </div>
          );
        })}
      </div>

      {popInConditions.offerPolicy && activeTab === CONDITIONS_TAB && (
        <Conditions offerPolicy={popInConditions.offerPolicy} />
      )}
      {popInConditions.offerDetails && activeTab === DETAILS_TAB && (
        <Details offerDetails={popInConditions.offerDetails} />
      )}
    </div>
  );
};

export default Tabs;
